module.exports = __webpack_public_path__ + "static/media/cake.dc01bc73.png";